import { getContrast } from "color2k";
import { useTheme } from "@mui/material/styles";
import React from "react";
/**
 * Returns either themes text color or white
 * whatever has the higher contrast ratio
 */
export const useContrastColor = (color) => {
    const theme = useTheme();
    const contrastColor = React.useMemo(() => {
        const contrastWithWhite = getContrast("#ffffff", color);
        const contrastWithThemeTextColor = getContrast(theme.palette.text.primary, color);
        return contrastWithWhite >= contrastWithThemeTextColor ? "#ffffff" : theme.palette.text.primary;
    }, [color, theme]);
    return contrastColor;
};
//# sourceMappingURL=use-contrast-color.js.map